// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function translateDate(strDate) {
  const dateString = strDate.split(' at ')[0];
  const timeString = strDate.split(' at ')[1];

  const parseDate = new Date(Date.parse(dateString));
  const options = {
    year: 'numeric', month: 'long', day: 'numeric',
  };

  const tradDate = parseDate.toLocaleDateString('es-MX', options);
  return (`${tradDate}, a las ${timeString}`);
}

d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'Febrero',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Ene.',
    'Feb.',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Ago.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dic.',
  ],
});

let chartData; let minValue; let maxValue; let minDomain; let maxDomain; let
  lastData; let recordDraw;

const lastWin = null;// d3.timeParse('%Y-%m-%d')('2000-01-01');

const margins = {
  top: 30,
  right: 70,
  bottom: 25,
  left: 44,
};

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const pluralizeDays = n => ((n > 1) ? `${n} days` : `${n} day`);

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

const metric = 'us_cancellations';
// const metric = 'us_delays';
d3.json('https://ix.cnn.io/data/flight-cancellations-delays/flight_cancellations_national_by_hour.json').then((jsondata) => {
  const { lastUpdatedStr, data } = jsondata;

  d3.select('p#timestamp')
    .text(`Datos actualizados por última vez el ${translateDate(lastUpdatedStr)}, hora de Miami.`);
  // Datos actualizados por última vez 22 de febrero de 2023 a las 9:34 a.m. ET (hora de Miami).

  chartData = data.filter(d => +d.datetime_est.split('-')[0] > 2022).map((d, i) => ({
    date: d3.timeParse('%Y-%m-%d %H:%M:%S')(d.datetime_est.split('-05:00')[0]),
    metricValue: +d[metric],
  })).sort((a, b) => a.date.getTime() - b.date.getTime());


  minValue = 0;
  maxValue = d3.max(chartData, d => d.metricValue);

  minDomain = d3.min(chartData, d => d.date);
  maxDomain = d3.max(chartData, d => d.date);

  lastData = chartData.filter(d => d.date == maxDomain)[0];


  draw();
  window.onresize = draw;
});


function draw() {
  // console.log(chartData);
  const container = d3.select('#graphic');
  container.html('');

  const initialWidth = container.node().clientWidth;
  const isMobile = initialWidth <= 500;
  const height = 400;

  const xTicks = isMobile ? 3 : 5;

  const chartHeight = height - margins.top - margins.bottom;
  const chartWidth = initialWidth - margins.left - margins.right;

  const xScale = d3.scaleTime()
    .domain([minDomain, maxDomain])
    .range([0, chartWidth]);

  const yScale = d3.scaleLinear()
    .domain([minValue, maxValue * 1.2])
    .range([chartHeight, 0]);

  const xAxis = d3.axisBottom()
    .scale(xScale)
    .ticks(xTicks)
    .tickFormat(d3.timeFormat('%b %-d'));

  const yAxis = d3.axisLeft()
    .scale(yScale)
    .tickSize(-chartWidth)
    .ticks(6)
    .tickFormat(d => formatNumber(d));

  const path = d3.line()
    .curve(d3.curveLinear)
    .x(d => xScale(d.date))
    .y(d => yScale(d.metricValue));

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', height);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, chartHeight]})`)
    .call(xAxis);

  g.append('g')
    .attr('class', 'grid y')
    .call(yAxis);

  const line = g.append('g')
    .attr('class', 'line');

  line.append('path')
    .datum(chartData)
    .attr('stroke', d => '#7c4ea5')
    .attr('stroke-width', isMobile ? '1' : '2')
    .attr('fill', 'none')
    .attr('d', path);

  d3.select('.grid.y .domain').remove();

  // label last data point
  const annotation = g.append('g')
    .attr('class', 'annotation')
    .attr('transform', `translate(${[xScale(lastData.date), yScale(lastData.metricValue)]})`);

  annotation.append('circle')
    .attr('r', '4')
    .attr('fill', '#7c4ea5')
    .attr('stroke', 'none');


  annotation.append('text')
    .attr('dx', '10px')
    .attr('dy', '.2em')
    .attr('class', 'annotation-date')
    .text(d3.timeFormat('%b %-d')(lastData.date));

  annotation.append('text')
    .attr('dx', '10px')
    .attr('class', 'annotation-value')
    .text(formatNumber(lastData.metricValue))
    .attr('dy', '1.4em');

  window.pymChild.sendHeight();
}
